angular.module('EdxCommonModule')
  .directive('edxHorizontalToggleButton', function () {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: '/resources/components/common/nav/edx-horizontal-toggle-button.directive.html',
      controller: [
          '$scope',
        function(
          $scope
      ) {

      }] // controller
    };
  });